import { FIELD_TYPE } from '@/constants'


import getLandlordPropMgr  from './helper/landlordPropMgr'

export default [
  {
    label: 'Shelter Verification',   
    type: FIELD_TYPE.HEADING
  },  
  {
    type: FIELD_TYPE.HEADING,
    vHtmlLabel() {
      return `<strong>Rental Company</strong>`
    },
    showLabel: true,
    showInReview: true
  }, 
  {
    apiKey: `shelter.rentalCompany.name`,
    label: 'Name',
    placeHolder: 'Enter name',
    type: FIELD_TYPE.NAME,
    maxLength: 100,
    required: true
  },
  {
    apiKey: `shelter.rentalCompany.phoneNumber`,
    label: 'Phone number',
    placeHolder: '(123) 456-7890',
    required: true,
    description: "Format: (123) 456-7890",
    type: FIELD_TYPE.PHONE,
    maxLength: 14,
    validation(value) {     
      if (!/^\d{10}$/.test(value.replace(/[^a-zA-Z0-9]+/g,''))) {
        return 'Please enter minimum 10 digits.'
      }
    }
  },
  {
    apiKey: `shelter.rentalCompany.address`,
    label: 'Address',
    placeHolder: 'Enter address',
    maxLength: 100,
    required: true    
  },
  {
    apiKey: `shelter.rentalCompany.fax`,
    label: 'Fax',
    placeHolder: '(123) 456-7890',               
    description: "Format: (123) 456-7890",
    type: FIELD_TYPE.PHONE,
    maxLength: 14,
    validation(value) {     
      if (!/^\d{10}$/.test(value.replace(/[^a-zA-Z0-9]+/g,''))) {
        return 'Please enter minimum 10 digits.'
      }
    }   
  },
    
  getLandlordPropMgr('shelter.landlordPropMgr.landlordPropMgrDetails'),
]